import React from 'react'
import { isEmpty } from 'lodash'
import { Box, Button, Typography } from '@material-ui/core'
import { ChevronLeft, ChevronRight } from 'react-feather'

import useFetch from 'hooks/useFetch'

import { LoadingFeedback } from 'components'
import {
  LessonSidebar,
  LessonAttachments,
  LessonPlayer,
} from 'views/Training/LessonContent/components'

import * as service from 'service'
import useStyles from './styles'

const LessonContentView = ({ lesson, courseModules }) => {
  const classes = useStyles()

  const { response, isLoading } = useFetch(
    service.dponet.trainingCourse.lessonContent,
    {
      lessonContentId: lesson?.entityId,
    },
    [lesson?.entityId],
  )

  const lessonContentData = isLoading ? {} : response?.data?.lessonContent
  const attachments = lessonContentData?.attachments || []

  return (
    <Box className={classes.body}>
      <LoadingFeedback open={isLoading} />
      <Box className={classes.mainContent}>
        {lessonContentData?.url && (
          <LessonPlayer url={lessonContentData?.url} />
        )}
        {!isEmpty(attachments) && (
          <LessonAttachments attachments={attachments} />
        )}
        <Typography className={classes.lessonTitle}>{lesson?.title}</Typography>
        {lessonContentData?.content && (
          <Box
            className={classes.lessonBody}
            dangerouslySetInnerHTML={{ __html: lessonContentData?.content }}
          />
        )}

        <Box className={classes.navigation}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<ChevronLeft />}
            disabled
            className={classes.prevButton}
          >
            Anterior
          </Button>
          <Button
            variant="contained"
            size="small"
            endIcon={<ChevronRight />}
            disabled
            className={classes.nextButton}
          >
            Próximo
          </Button>
        </Box>
      </Box>
      <LessonSidebar
        modules={courseModules}
        activeLessonId={lesson?.id}
        portalToken={null}
        courseId={null}
        history={null}
        disabled
      />
    </Box>
  )
}
export default LessonContentView
